import "../../index29.css";
import { jsxs as z, jsx as i } from "react/jsx-runtime";
import { useMemo as S } from "react";
import { _ as t } from "../../cs-Dfox81s-.js";
import "../../type-Dku6Xzl6.js";
import p from "../../hooks/useSpacingToken.js";
import { gapSpacings as f, fullSpacings as D } from "../../utils/style.js";
const L = "_inline-layout_1wtri_1", O = "_with-inline-display_1wtri_5", x = "_start-aligned-content_1wtri_9", P = "_end-aligned-content_1wtri_13", j = "_after-content_1wtri_17", M = "_before-content_1wtri_18", k = "_children_1wtri_56", E = "_ellipsized_1wtri_61", n = {
  inlineLayout: L,
  withInlineDisplay: O,
  startAlignedContent: x,
  endAlignedContent: P,
  afterContent: j,
  beforeContent: M,
  children: k,
  ellipsized: E
};
function J(m) {
  const {
    className: _,
    elementRef: C,
    before: o,
    beforeContainerClassName: g,
    children: h,
    childrenContainerClassName: w,
    after: s,
    afterContainerClassName: u,
    spacing: r,
    spacingOffset: a,
    withPadding: l,
    withoutSpacingOpticalCorrection: c,
    withAdditionalInlinePadding: y,
    withEllipsizedContent: N,
    contentAlignment: d = "center",
    withInlineDisplay: A,
    ...b
  } = m, I = S(() => l ? D : f, [l]), v = p({
    spacing: r,
    modes: I,
    offset: a ?? 0,
    withAdditionalInlinePadding: y,
    withoutOpticalCorrection: c
  }), e = p({
    spacing: r,
    modes: f,
    offset: a ?? 0,
    withoutOpticalCorrection: c
  });
  return /* @__PURE__ */ z(
    "div",
    {
      ...b,
      ref: C,
      className: t(
        n.inlineLayout,
        v,
        d === "start" && n.startAlignedContent,
        d === "end" && n.endAlignedContent,
        A && n.withInlineDisplay,
        _
      ),
      children: [
        o && /* @__PURE__ */ i(
          "div",
          {
            className: t(
              n.beforeContent,
              e,
              g
            ),
            children: o
          }
        ),
        /* @__PURE__ */ i(
          "div",
          {
            className: t(
              n.children,
              e,
              w,
              N && n.ellipsized
            ),
            children: h
          }
        ),
        s && /* @__PURE__ */ i(
          "div",
          {
            className: t(
              n.afterContent,
              u,
              e
            ),
            children: s
          }
        )
      ]
    }
  );
}
export {
  J as default
};
